/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { settings, LoginAuditControllerApi } from '@api/backend'

const prefix = 'admin/loginaudit'

export const GET_LOGIN_AUDIT = `${prefix}/GET_DATA`
export const GET_FILTROS_LOGIN_AUDIT = `${prefix}/GET_FILTROS`
export const GET_DETALLE_LOGIN_AUDIT = `${prefix}/GET_DETALLE`

const apiLoginAudit = new LoginAuditControllerApi(settings)

// Motivos que guarda el backend en la columna reason al fallar un login.
export const MOTIVOS_FALLO = ['usuario_no_encontrado', 'password_invalida', 'error_no_controlado']

// Devuelve una fecha en formato 'YYYY-MM-DD', el mismo que usa el backend al auditar.
const aFechaIso = (fecha) => fecha.toLocaleDateString('sv-SE')

// Por defecto la pantalla arranca acotada a los ultimos 7 dias para no barrer toda la tabla.
export const getRangoFechasPorDefecto = () => {
    const hasta = new Date()
    const desde = new Date()
    desde.setDate(desde.getDate() - 6)

    return {
        fechaDesde: aFechaIso(desde),
        fechaHasta: aFechaIso(hasta)
    }
}

// Valores iniciales de los inputs de busqueda.
export const getFiltrosPorDefecto = () => ({
    email: '',
    reason: 'todos',
    ipAddress: '',
    ...getRangoFechasPorDefecto()
})

export const getLoginAudit = params => {
    return async (dispatch) => {
        try {
            const { page = 1, perPage = 10, filtrosBusqueda } = params
            const { email, reason, ipAddress, fechaDesde, fechaHasta } = filtrosBusqueda || getFiltrosPorDefecto()

            const condiciones = []

            if (email) {
                condiciones.push({ emailAttempted: { like: `%${email}%` } })
            }

            if (reason && reason !== 'todos') {
                condiciones.push({ reason })
            }

            if (ipAddress) {
                condiciones.push({ ipAddress: { like: `%${ipAddress}%` } })
            }

            // createdAt se guarda como 'YYYY-MM-DD HH:mm:ss', asi que el orden alfabetico coincide con el cronologico.
            if (fechaDesde && fechaHasta) {
                condiciones.push({ createdAt: { between: [`${fechaDesde} 00:00:00`, `${fechaHasta} 23:59:59`] } })
            }

            const where = condiciones.length > 0 ? { and: condiciones } : undefined

            const filter = {
                offset: ((page - 1) * perPage),
                limit: perPage,
                skip: ((page - 1) * perPage),
                order: ['createdAt DESC'],
                // details y rawError son TEXT y solo hacen falta en el detalle, no en el listado.
                fields: { details: false, rawError: false },
                ...(where ? { where } : {})
            }

            const { data: dataLoginAudit } = await apiLoginAudit.loginAuditControllerFind(JSON.stringify(filter))
            const { data: dataLoginAuditCount } = await apiLoginAudit.loginAuditControllerCount(where ? JSON.stringify(where) : undefined)

            dispatch({
                type: GET_LOGIN_AUDIT,
                data: dataLoginAudit,
                total: dataLoginAuditCount.count || 0,
                params
            })

            // Guardamos los filtros de busqueda (Inputs) para que sobrevivan a la navegacion.
            dispatch({
                type: GET_FILTROS_LOGIN_AUDIT,
                filtros: filtrosBusqueda
            })
        } catch (err) {
            console.error(err.message)
        }
    }
}

// Recupera el registro completo (con details y rawError) para el modal de detalle.
export const getDetalleLoginAudit = (id) => {
    return async (dispatch) => {
        try {
            const { data } = await apiLoginAudit.loginAuditControllerFindById(id)
            dispatch({
                type: GET_DETALLE_LOGIN_AUDIT,
                selectedRegistro: data
            })
        } catch (err) {
            console.error(err.message)
        }
    }
}

export const limpiarDetalleLoginAudit = () => {
    return async (dispatch) => {
        dispatch({
            type: GET_DETALLE_LOGIN_AUDIT,
            selectedRegistro: null
        })
    }
}
